import { Routes } from '@angular/router';
import { BookingMediaStore } from './campaign/placements/booking-media.store';
import { CampaignStore } from './campaign/campaign.store';

export const CAMPAIGN_ROUTES: Routes = [
	{
		path: '',
		loadComponent: () => import('./campaigns.component').then((m) => m.CampaignsComponent),
		children: [
			{
				path: 'touchpoints',
				loadComponent: () =>
					import('./campaigns-touchpoints/touchpoint-grid.component').then((m) => m.TouchpointGridComponent),
			},
			{
				path: 'overview',
				loadComponent: () => import('./campaigns-overview/booking-list.component').then((m) => m.BookingListComponent),
			},
			{
				path: 'segmentation',
				loadComponent: () =>
					import('./campaigns-segmentation/campaigns-segmentation.component').then(
						(m) => m.CampaignsSegmentationComponent
					),
			},
		],
	},
	{
		path: 'create',
		loadComponent: () => import('./campaign/campaign.component').then((m) => m.CampaignComponent),
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./campaign/campaign-details/campaigns-details.component').then((m) => m.CampaignDetailsComponent),
			},
		],
		data: {
			'background-color': 'var(--white)',
			heading: 'Create Campaign',
			isCreating: true,
		},
	},
	{
		path: '',
		providers: [CampaignStore, BookingMediaStore],
		children: [
			{
				path: ':campaignId',
				loadComponent: () => import('./campaign/campaign.component').then((m) => m.CampaignComponent),
				children: [
					{
						path: '',
						loadComponent: () =>
							import('./campaign/campaign-details/campaigns-details.component').then((m) => m.CampaignDetailsComponent),
					},
					{
						path: 'history',
						loadComponent: () =>
							import('./campaign/campaign-history/campaign-history.component').then((m) => m.CampaignHistoryComponent),
					},
				],
				data: {
					'background-color': 'var(--white)',
					heading: 'Edit Campaign',
				},
			},
			{
				path: ':campaignId/placements/:placementId',
				loadComponent: () => import('./campaign/placements/placements.component').then((m) => m.PlacementsComponent),
				children: [
				{
					path: 'reach',
					loadComponent: () =>
						import('./campaign/placements/placement-reach/placement-reach.component').then(
							(m) => m.PlacementReachComponent
						),
				},
				{
						path: 'media',
						loadComponent: () =>
							import('./campaign/placements/placement-media/placement-media.component').then(
								(m) => m.PlacementMediaComponent
							),
					},
				],
				data: {
					'background-color': 'var(--white)',
				},
			},
		],
	},
];
